import { render } from "./ClientBudgets.vue?vue&type=template&id=bb736138&scoped=true"
import script from "./ClientBudgets.vue?vue&type=script&lang=js"
export * from "./ClientBudgets.vue?vue&type=script&lang=js"

import "./ClientBudgets.vue?vue&type=style&index=0&id=bb736138&lang=scss&scoped=true"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb736138"]])

export default __exports__